<template>
  <div id="AlignmentPanel" class="row mlr0">
    <div class="row">
      <div class="col-xs-12">
        <div
          class="left"
          :class="'col-xs-' + 12/$store.getters.divider"
        >
          <el-radio-group v-model="alignment">
            <el-radio
              v-for="(i, index) in alignmentData[layoutStyle]"
              :label="i.label"
              :key="index"
            >
              <div class="inlineb ">
                <div class="border inlineb">
                  <span
                    :title="i.name"
                    :class="i.iconClass"
                    class=" button-icon-small click"
                  ></span>
                </div>
                <p class="name-mc">
                  {{ i.name }}
                </p>
              </div>
            </el-radio>
          </el-radio-group>
        </div>

        <div class="right" :class="{['col-xs-' + 12/$store.getters.divider] : true,
    'bdr-d' : !$store.getters.isVertical, 'bdrt-d' : $store.getters.isVertical}" v-if="format != 'single'">
          <el-radio-group v-model="rightAlignment">
            <el-radio
              v-for="(i, index) in alignmentData[rightLayoutStyle]"
              :label="i.label"
              :key="index"
            >
              <div class="inlineb">
                <div class="border inlineb">
                  <span
                    :title="i.name"
                    :class="i.iconClass"
                    class=" button-icon-small click"
                  ></span>
                </div>
                <p class="name-mc">
                  {{ i.name }}
                </p>
              </div>
            </el-radio>
          </el-radio-group>
        </div>

        <div :class="{['col-xs-' + 12/$store.getters.divider] : true,
    'bdr-d' : !$store.getters.isVertical, 'bdrt-d' : $store.getters.isVertical}" v-if="$store.getters.isTriple">
          <el-radio-group v-model="tripleRightAlignment">
            <el-radio
              v-for="(i, index) in alignmentData[tripleRightLayoutStyle]"
              :label="i.label"
              :key="index"
            >
              <div class="inlineb">
                <div class="border inlineb">
                  <span
                    :title="i.name"
                    :class="i.iconClass"
                    class=" button-icon-small click"
                  ></span>
                </div>
                <p class="name-mc">
                  {{ i.name }}
                </p>
              </div>
            </el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AlignmentPanel",
  props: [],
  data() {
    return {
      format: null,
      alignment: null,
      rightAlignment: null,
      tripleRightAlignment: null,
      layout: null,
      layoutStyle: null,
      rightLayout: null,
      rightLayoutStyle: null,
      tripleRightLayout: null,
      tripleRightLayoutStyle: null,
      alignmentData: [],
    };
  },
  created: function() {
    //Alignments
    let topleft = {
      label: "topleft",
      name: "Top Left",
      iconClass: "el-icon-top-left",
    };
    // let topcenter = {
    //   label: "topcenter",
    //   name: "Top Center",
    //   iconClass: "el-icon-top-center",
    // };
    let topright = {
      label: "topright",
      name: "Top Right",
      iconClass: "el-icon-top-right",
    };
    let middleleft = {label:'topleft',name:'Middle Left',iconClass:'el-icon-left-middle'}
    let middlecenter = {label:'topcenter',name:'Middle Center',iconClass:'el-icon-center-middle'}
    let middleright = {label:'topright',name:'Middle Right',iconClass:'el-icon-right-middle'}
    let bottomleft = {
      label: "bottomleft",
      name: "bottom Left",
      iconClass: "el-icon-bottom-left",
    };
    // let bottomcenter = {
    //   label: "bottomcenter",
    //   name: "bottom Center",
    //   iconClass: "el-icon-bottom-center",
    // };
    let bottomright = {
      label: "bottomright",
      name: "bottom Right",
      iconClass: "el-icon-bottom-right",
    };

    this.alignmentData = {
        iconOnly: [middleleft, middlecenter, middleright],
        singleLineText: [middleleft, middlecenter, middleright],
        doubleLineText: [middleleft, middlecenter, middleright],
        iconSingleLineText: [topleft, topright, bottomleft, bottomright],
        iconDoubleLineText: [topleft, topright, bottomleft, bottomright],
        socket: []
    };

    this.format = this.$store.state.artwork.format;
    this.layoutStyle = this.$store.state.artwork.layoutStyle;
    this.rightLayoutStyle = this.$store.state.artwork.rightLayoutStyle;
    this.tripleRightLayoutStyle = this.$store.state.artwork.tripleRightLayoutStyle;
    this.layout = this.$store.state.artwork.layout;
    this.rightLayout = this.$store.state.artwork.rightLayout;
    this.tripleRightLayout = this.$store.state.artwork.tripleRightLayout;
    this.alignment = this.$store.state.artwork.alignment;
    this.rightAlignment = this.$store.state.artwork.rightAlignment;
    this.tripleRightAlignment = this.$store.state.artwork.tripleRightAlignment;
  },
  watch: {
    alignment: {
      handler(val) {
        this.$store.state.artwork.alignment = val;
      },
    },
    rightAlignment: function(val) {
      this.$store.state.artwork.rightAlignment = val;
    },
    tripleRightAlignment: function(val) {
      this.$store.state.artwork.tripleRightAlignment = val;
    },
  },
};
</script>
